import { Reducer } from '@reduxjs/toolkit'

import {
  deleteByProperty,
  updateByProperty,
  updateByQuestionProperty,
} from '../../../App/Helpers/reducer'
import { SurveyObject, ISurveyQuestion } from '../Client/ISurvey'

import {
  ActionTypes,
  SurveyDispatchTypes as DT
} from './ActionTypes'


type SurveyState = {
  list: SurveyObject[]
  isLoading: boolean
  error: boolean
}

const initialState: SurveyState = {
  isLoading: false,
  error: false,
  list: [],
}

export const surveyReducer: Reducer<SurveyState, ActionTypes> = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case DT.GET_SURVEYS_REQUEST:
      return {
        ...state,
        isLoading: true,
      }
    case DT.GET_SURVEYS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: false,
        list: action.payload.surveys,
      }
    case DT.GET_SURVEYS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
        list: [],
      }
    case DT.DELETE_SURVEY_SUCCESS:
      return {
        ...state,
        list: deleteByProperty(state.list, 'id', action.payload.survey),
      }
    // case DT.UPDATE_SURVEY_SUCCESS:
    //   const updatedQuestionIndex = state.list.findIndex(
    //     (value: SurveyObject) => action.payload.survey.id === value.id,
    //   )

    //   if (-1 === updatedQuestionIndex) {
    //     return state
    //   }

    //   return {
    //     ...state,
    //     list: [
    //       ...state.list.slice(0, updatedQuestionIndex),
    //       action.payload.survey,
    //       ...state.list.slice(updatedQuestionIndex + 1),
    //     ],
    //   }
    case DT.ADD_SURVEY_SUCCESS:
      const payloadDate = action.payload.survey
      const newSurvey: SurveyObject = {
        id: payloadDate.id,
        establishment: payloadDate.establishment,
        name: payloadDate.name,
        mailSubject: payloadDate.mailSubject,
        createdAt: payloadDate.createdAt,
        description: payloadDate.description,
        isSendAfterAppointment: false,
        questions: [],
        triggers: [],
        updatedAt: payloadDate.updatedAt,
        language: payloadDate.language,
      }
      return {
        ...state,
        list: [...state.list, newSurvey],
      }
    case DT.UPDATE_SURVEY_NAME_SUCCESS:
      return {
        ...state,
        list: updateByProperty(
          [...state.list],
          'id',
          action.payload.survey.surveyId,
          (originalSurvey: SurveyObject) => {
            return {
              ...originalSurvey,
              name: action.payload.survey.name,
            }
          },
        ),
      }
    case DT.UPDATE_SURVEY_NAME_FAILURE:
      return {
        ...state,
        ...state,
        isLoading: false,
        error: true,
        list: [],
      }
    case DT.UPDATE_SURVEY_DESCRIPTION_SUCCESS:
      return {
        ...state,
        list: updateByProperty(
          [...state.list],
          'id',
          action.payload.survey.surveyId,
          (originalSurvey: SurveyObject) => {
            return {
              ...originalSurvey,
              description: action.payload.survey.description,
            }
          },
        ),
      }
    case DT.UPDATE_SURVEY_DESCRIPTION_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
        list: [],
      }
    case DT.UPDATE_SURVEY_MAIL_SUBJECT_SUCCESS:
      return {
        ...state,
        list: updateByProperty(
          [...state.list],
          'id',
          action.payload.survey.surveyId,
          (originalSurvey: SurveyObject) => {
            return {
              ...originalSurvey,
              mailSubject: action.payload.survey.mailSubject,
            }
          },
        ),
      }
    case DT.UPDATE_SURVEY_MAIL_SUBJECT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
        list: [],
      }
    case DT.ADD_QUESTION_SUCCESS:
      return {
        ...state,
        list: updateByQuestionProperty(
          [...state.list],
          'id',
          action.payload.surveyId,
          (originalSurvey: SurveyObject) => {
            return {
              ...originalSurvey,
              questions: [
                ...(originalSurvey.questions || []),
                action.payload.question,
              ],
            }
          },
        ),
      }
    case DT.ADD_QUESTION_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
        list: [],
      }

    case DT.UPDATE_QUESTION_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
        list: [],
      }
    case DT.UPDATE_QUESTION_SUCCESS:
      return {
        ...state,
        list: updateByQuestionProperty(
          [...state.list],
          'id',
          action.payload.surveyId,
          (originalSurvey: SurveyObject) => {
            return {
              ...originalSurvey,
              questions: updateByQuestionProperty(
                [...originalSurvey.questions],
                'id',
                action.payload.question.id,
                action.payload.question,
              ),
            }
          },
        ),
      }
    case DT.DELETE_QUESTION_SUCCESS:
      const deleteSurveyIndex = [...state.list].findIndex(
        (survey: SurveyObject) => action.payload.surveyId === survey.id,
      )
      const deleteQuestionIndex = (
        state.list[deleteSurveyIndex]?.questions || []
      ).findIndex(
        (question: ISurveyQuestion) =>
          action.payload.questionId === question.id,
      )

      return {
        ...state,
        list: updateByQuestionProperty(
          [...state.list],
          'id',
          action.payload.surveyId,
          (originalSurvey: SurveyObject) => {
            return {
              ...originalSurvey,
              questions: [
                ...(originalSurvey.questions || []).slice(
                  0,
                  deleteQuestionIndex,
                ),
                ...(originalSurvey.questions || []).slice(
                  deleteQuestionIndex + 1,
                ),
              ],
            }
          },
        ),
      }
    case DT.UPDATE_QUESTIONS_ORDER_SUCCESS:
      return {
        ...state,
        list: updateByQuestionProperty(
          [...state.list],
          'id',
          action.payload.surveyId,
          (originalSurvey: SurveyObject) => {
            return {
              ...originalSurvey,
              questions: [...(originalSurvey.questions || [])].map(
                originalQuestion => {
                  return {
                    ...originalQuestion,
                    order: action.payload.questionIds.findIndex(
                      questionId => questionId === originalQuestion.id,
                    ),
                  }
                },
              ),
            }
          },
        ),
      }

    case DT.CREATE_SURVEY_TRIGGER_SUCCESS:
      return {
        ...state,
        list: updateByProperty(
          [...state.list],
          'id',
          action.payload.surveyId,
          (originalSurvey: SurveyObject) => ({
            ...originalSurvey,
            triggers: [
              ...originalSurvey.triggers,
              { ...action.payload.trigger },
            ],
          }),
        ),
      }

    case DT.DELETE_SURVEY_TRIGGER_SUCCESS:
      return {
        ...state,
        list: updateByProperty(
          [...state.list],
          'id',
          action.payload.surveyId,
          (originalSurvey: SurveyObject) => {
            return {
              ...originalSurvey,
              triggers: deleteByProperty(
                originalSurvey.triggers || [],
                'uuid',
                action.payload.uuid,
              ),
            }
          },
        ),
      }

    case DT.UPDATE_SURVEY_TRIGGER_SUCCESS:
      return {
        ...state,
        list: updateByProperty(
          [...state.list],
          'id',
          action.payload.surveyId,
          (originalSurvey: SurveyObject) => {
            return {
              ...originalSurvey,
              triggers: updateByProperty(
                originalSurvey.triggers || [],
                'uuid',
                action.payload.trigger.uuid,
                action.payload.trigger,
              ),
            }
          },
        ),
      }
    default:
      return state
  }
}
